import React from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { Navigation, MapPin } from "lucide-react";
import { CiLocationArrow1, CiLocationOn } from "react-icons/ci";

export default function AutoComplete({
  handleSelect,
  coordinates,
  address,
  setAddress,
  isRequired,
  handleLocateMe,
  showLocateMe,
  homePage,
  reduceButton,
}) {
  console.log("homePage", homePage);
  console.log("reduceButton", reduceButton);
  return (
    <div>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="mb-2 position-relative" style={{ width: "100%" }}>
            {/* <div style={{ position: "relative" }}>
              <input
                className="form-control f-14"
                style={{ paddingRight: "40px" }}
                {...getInputProps({ placeholder: "Search By Map" })}
                required={isRequired ? true : false}
              />

              {showLocateMe && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={handleLocateMe}
                  style={{
                    position: "absolute",
                    right: "5px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 100,
                  }}
                >
                  Locate me!📍
                </button>
              )}
            </div> */}
            {homePage === true ? (
              <div className="location-search">
                <div className="input-group">
                  <span className="input-group-text">
                    <MapPin size={20} color="#0fb4e4" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    // placeholder="What's your address?"
                    {...getInputProps({ placeholder: "What's your address?" })}
                    required={isRequired ? true : false}
                  />
                  <button
                    className="btn use-location-btn"
                    onClick={handleLocateMe}
                  >
                    <Navigation size={16} color="#0fb4e4" />
                    <span>Use Current location</span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="address-input-wrapper">
                <div style={{ position: "relative", width: "100%" }}>
                  <CiLocationOn
                    style={{
                      position: "absolute",
                      left: "7px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "20px",
                      color: "#17a2b8",
                    }}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <input
                    style={{
                      width: "90%",
                      paddingLeft: "10px", // enough space for the icon
                    }}
                    type="text"
                    {...getInputProps({ placeholder: "What's your address?" })}
                    required={isRequired ? true : false}
                  />
                </div>
                <div>
                  <button
                    className="location-button"
                    style={{ width: reduceButton ? "100px" : "200px" }}
                    onClick={handleLocateMe}
                  >
                    <CiLocationArrow1 />
                    &nbsp;
                    {reduceButton === true ? "Current" : "Use Current Location"}
                  </button>
                </div>
              </div>
            )}

            {suggestions.length > 0 && (
              <div
                className="position-absolute bg-light py-4 px-2 w-100"
                style={{ zIndex: 50, maxHeight: 200, overflowY: "scroll" }}
              >
                {loading ? <div>...loading</div> : null}
                {suggestions.map((suggestion) => (
                  <div
                    className={`border-grey rounded-md px-2 py-2 ${
                      suggestion.active ? "bg-primary text-white" : ""
                    }`}
                    {...getSuggestionItemProps(suggestion)}
                  >
                    {suggestion.description}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
}
